module.exports = __webpack_public_path__ + "static/media/parts_08.313d0df5.svg";